import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface AdminOnboardingTaskGroupHeaderProps {
  children: ReactNode;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  margin-top: 8px;
  margin-bottom: 4px;

  &:first-child {
    margin-top: 0;
  }

  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.bold};
  line-height: 1.2;
`;

/*
 * Component.
 */

export const AdminOnboardingTaskGroupHeader: FC<AdminOnboardingTaskGroupHeaderProps> = (props) => (
  <StyledDiv>{props.children}</StyledDiv>
);
